import {
  TUser,
  IAuthenticatedUser,
} from '@cian/api-models/monolith-python/cian-api/site/v1/get-user-data-by-request';

export function isAuthenticatedUser(userForCheck: TUser): userForCheck is IAuthenticatedUser {
  return 'email' in userForCheck;
}
